"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionSchema = exports.RoleSchema = void 0;
const zod_1 = require("zod");
exports.RoleSchema = zod_1.z.object({
    roleId: zod_1.z.number(),
    code: zod_1.z.string().nullable(),
    name: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
});
exports.PermissionSchema = zod_1.z.object({
    permissionId: zod_1.z.number(),
    code: zod_1.z.string().nullable(),
    name: zod_1.z.string().nullable(),
    resourceId: zod_1.z.number().nullable(),
    operationId: zod_1.z.number().nullable(),
});
